import { Injectable } from '@angular/core';
import { MessageService, MessageFreeVoicesReady } from './message.service';
import { SharedUtilService } from './shared-util.service';
import { AppService } from './app.service';
import { UtilService } from './util.service';
import { LocalAcaVoicesService } from './local-aca-voices.service';
import { UtilVoicesService } from './util-voices.service';
declare const $: any;

export enum VoiceType {
  iosAca = 'iosAca',
  iosSystem = 'iosSystem',
  androidSystem = 'androidSystem',
  iosAcaNeedDownload = 'iosAcaNeedDownload'
}

export class FreeVoice {
  constructor(
    public key: string = '',
    public name: string,
    public language: string,
    public localeName: string = '',
    public displayLocale: boolean = false,
    public source: string,
    public languageName: string,
    public voice: any,
    public noAuth: boolean = true,
    public id: string = null,
    public type: string = 'free'
  ) {
    console.log("new free voice", this);
  }
}

@Injectable({
  providedIn: 'root'
})
export class FreeVoicesService {
  private voices: Map<string, FreeVoice>;
  private appleLangs = [];
  private hasGoogleEngine = true;
  private tryNum = 5;
  private isFreeVoicesReady = false;
  private isGettingFreeVoices = false;

  constructor(private messageService: MessageService,
    private localAcaVoicesService: LocalAcaVoicesService,
    private sharedUtilService: SharedUtilService,
    private utilService: UtilService,
    private voiceUtilService: UtilVoicesService) {
    // this.getFreeVoices();

    let delayTime = 500;
    if (AppService.isAndroid() || AppService.isIOS()) {
      delayTime = 2000;
    }

    const timeInterVal = setInterval(() => {

      if (this.isFreeVoicesReady) {
        clearInterval(timeInterVal);
        return;
      }

      if ((this.voices && this.voices.size > 0) || !this.hasGoogleEngine || this.tryNum == 0) {
        clearInterval(timeInterVal);
        this.messageService.sendMessage({ name: MessageFreeVoicesReady });
        this.isFreeVoicesReady = true;
        return;
      }
      if (!this.isGettingFreeVoices) {
        if (AppService.isAndroid() || AppService.isIOS()) {
          if (window["cordova-plugin-ready"]) {
            this.getFreeVoices();
            this.tryNum--;
          }
        } else {
          this.getFreeVoices();
          this.tryNum--;
        }
      }
    }, delayTime);
  }

  public getFreeVoicesReadyState() {
    return this.isFreeVoicesReady;
  }

  public getFreeVoices() {
    this.isGettingFreeVoices = true;
    this.voices = new Map<string, FreeVoice>();
    this.getVoicesFromSpeechSynthesis()
      .then((voices) => {
        this.setVoices(voices)
          .then(() => {
            if (this.voices && this.voices.size > 0) {
              this.messageService.sendMessage({ name: MessageFreeVoicesReady });
              this.isFreeVoicesReady = true;
            }
          })
      })
      .catch((err) => {
        console.log("err in getFreeVoices", err);
      });
    this.isGettingFreeVoices = false;
  }

  public getVoicesFromSpeechSynthesis(): Promise<any> {
    return new Promise(function(resolve, reject) {
      if (AppService.isPW() || AppService.isAndroid() || AppService.isIOS()) {
        if (!window || !window.speechSynthesis)
          resolve([]);
        const synth = window.speechSynthesis;
        if (synth !== null && typeof (synth) !== 'undefined') {
          let id;
          id = setInterval(() => {
            let voices = synth.getVoices();
            // console.log('voices: ', voices);
            if (voices.length !== 0) {
              resolve(voices);
              clearInterval(id);
            }
          }, 10);
        } else {
          resolve([]);
        }

        setTimeout(() => {
          resolve([]);
        }, 2000);
      } else {
        resolve([]);
      }

    })
      .then((voices) => {
        if (AppService.appBrowser === 'iosBrowser') {
          voices = this.filterIOSVoices(voices);
          return Promise.resolve(voices);
        } else {
          return Promise.resolve(voices);
        }
      })
      .catch((err) => {
        console.log('getVoicesFromSpeechSynthesis', err);
      });
  }

  private filterIOSVoices(voices) {
    const iOSVoiceNames = {
      'Maged': ['ar-SA'],
      'Zuzana': ['cz-CZ'],
      'Sara': ['da-DK'],
      'Anna': ['de-DE'],
      'Melina': ['ru-RU'],
      'Karen': ['en-IR'],
      'Samantha': ['en-US'],
      'Daniel': ['en-GB'],
      'Rishi': ['en-IN'],
      'Moira': ['en-IE'],
      'Tessa': ['en-ZA'],
      'Mónica': ['es-ES'],
      'Paulina': ['es-MX'],
      'Satu': ['fi-FI'],
      'Amélie': ['fr-CA'],
      'Thomas': ['fr-FR'],
      'Carmit': ['he-IL'],
      'Lekha': ['hi-IN'],
      'Mariska': ['hu-HU'],
      'Damayanti': ['id-ID'],
      'Alice': ['it-IT'],
      'Kyoko': ['ja-JP'],
      'Yuna': ['ko-KR'],
      'Ellen': ['nl-BE'],
      'Xander': ['nl-NL'],
      'Nora': ['nb-NO', 'no-NO'],
      'Zosia': ['pl-PL'],
      'Luciana': ['pt-BR'],
      'Joana': ['pt-PT'],
      'Ioana': ['ro-RO'],
      'Milena': ['ru-RU'],
      'Laura': ['sk-SK'],
      'Alva': ['sv-SE'],
      'Kanya': ['th-TH'],
      'Yelda': ['tr-TR'],
      'Tian-Tian': ['zh-CN'],
      'Sin-Ji': ['zh-HK'],
      'Mei-Jia': ['zh-TW'],
    }
    const iOSVoices = []
    for (let i = 0; i < voices.length; i++) {
      if (voices[i].name in iOSVoiceNames && iOSVoiceNames[voices[i].name].includes(voices[i].lang)) {
        iOSVoices.push(voices[i])
      }
    }
    return iOSVoices;
  }

  setVoices(synthVoices) {
    return new Promise((resolve, reject) => {
      if (this.voices.size != 0) {
        return;
      }

      let voices = synthVoices;
      let temp: Array<FreeVoice> = [];
      // temp = temp.concat(this.setAttVoices());

      for (let i = 0; i < voices.length; i++) {
        let voice: SpeechSynthesisVoice = voices[i];
        let source = this.getVoiceSource(voice);
        let name = this.getName(voice.name, source);
        let lang = voice.lang;
        lang = this.getLanguage(lang, name);
        if (lang === '') {
          continue;
        }
        let key = name + ' ' + lang + ' ' + 'free';
        let languageLocale = this.voiceUtilService.getLanguageAndLocaleForVoiceList(lang);
        let freeVoice = new FreeVoice(key, name, lang, languageLocale.localeName, languageLocale.displayLocale, source, languageLocale.languageName, voice);
        temp.push(freeVoice);
      }
      if (AppService.isPW()) {
        resolve(temp);
      } else if (AppService.isAndroid()) {
        // cordova invoke app's native function to get android mobile's local system voices
        const cordovaVoices = [];
        (<any>window).cordova.plugins.ttsplugin.coolMethod(
          ['system#voices'],
          (s) => {
            if (s == '[]') {
              this.hasGoogleEngine = false;
              resolve(temp);
              return;
            }
            const systemVoices = JSON.parse(s);
            systemVoices.forEach(voice => {
              let languageLocale = this.voiceUtilService.getLanguageAndLocaleForVoiceList(voice['Language']);
              let key = this.formatAndroidVoiceName(voice['Name']) + ' ' + voice['Language'] + ' ' + 'free';
              // const localVoice = new FreeVoice(this.formatAndroidVoiceName(voice['Name']), voice['Language'], VoiceType.androidSystem, voice['Name'])
              const localVoice = new FreeVoice(key, this.formatAndroidVoiceName(voice['Name']), voice['Language'], languageLocale.localeName, languageLocale.displayLocale, VoiceType.androidSystem, languageLocale.languageName, voice['Name']);
              cordovaVoices.push(localVoice);
            });
            temp = temp.concat(cordovaVoices);
            resolve(temp);
          }, err => {
            //alert('error' + err);
            //this.hasGoogleEngine = false;
            resolve([]);
          });
      } else if (AppService.isIOS()) {
        // cordova invoke app's native function to get iphone's system voices list
        const cordovaVoices = [];
        //const localVoice = new FreeVoice('Ryan', 'en-US', VoiceType.iosAca, 'Ryan');
        //cordovaVoices.push(localVoice);
        (<any>window).cordova.plugins.ttsplugin.coolMethod(
          ['cordova#voices'],
          (s) => {
            console.log('callback requestPay success', s);
            const allVoices = JSON.parse(s);
            // const acaVoicesStatus = allVoices['aca'];
            const systemVoicesStatus = allVoices['system'];
            // acaVoicesStatus.forEach(voice => {
            //   if (voice['DownloadStatus']) {
            //     cordovaVoices.push(new FreeVoice(voice['Name'], voice['Language'], VoiceType.iosAca, voice['Name']));
            //   } else {
            //     cordovaVoices.push(new FreeVoice(voice['Name'], voice['Language'], VoiceType.iosAcaNeedDownload, voice['Name']));
            //   }
            // });
            systemVoicesStatus.forEach(voice => {
              // cordovaVoices.push(new FreeVoice(voice['Name'], voice['Language'], VoiceType.iosSystem, voice['Name']));
              let languageLocale = this.voiceUtilService.getLanguageAndLocaleForVoiceList(voice['Language']);
              let key = voice['Name'] + ' ' + voice['Language'] + ' ' + 'free';
              cordovaVoices.push(new FreeVoice(key, voice['Name'], voice['Language'], languageLocale.localeName, languageLocale.displayLocale, VoiceType.iosSystem, languageLocale.languageName, voice['Name'] + " " + voice['Language']));
            });
            //alert(JSON.stringify(cordovaVoices));
            resolve(cordovaVoices);
          }, err => {
            console.log('callback requestPay err', err);
            resolve([]);
          }
        );
      } else {
        const localAcaVoices = [];
        var voiceNames = [];
        this.localAcaVoicesService.getLocalAcaVoices().then(localAcaList => {
          if (this.sharedUtilService.getSystem() == 'windows') {
            temp = [];
            localAcaList.forEach(item => {
              if (item != '') {
                var infos = item.split('#');
                var idname = $.trim(infos[0].substr(7));
                var voicename = $.trim(infos[1].substr(9));
                var language = $.trim(infos[2].substr(10));
                var type = $.trim(infos[4].substr(6));

                if (language.indexOf("USEnglish") >= 0) {
                  language = "en-US";
                }
                if (language.indexOf("409") >= 0) {
                  language = "en-US";
                }


                if (language.indexOf("804") >= 0) {
                  language = "zh-CN";
                }
                if (language.indexOf("MandarinChinese") >= 0) {
                  language = "zh-CN";
                }

                if (language.indexOf("809") >= 0) {
                  language = "en-UK";
                }
                // if (language.indexOf("409") >= 0) {
                //   language = "en-GB";
                // }
                if (language.indexOf("407") >= 0) {
                  language = "de-DE";
                }
                if (language.indexOf("410") >= 0) {
                  language = "it-IT";
                }
                if (language.indexOf("41d") >= 0) {
                  language = "sv-SE";
                }
                if (language.indexOf("413") >= 0) {
                  language = "nl-NL";
                }
                if (language.indexOf("40c") >= 0) {
                  language = "fr-FR";
                }
                if (language.indexOf("c0c") >= 0) {
                  language = "fr-CA";
                }
                if (language.indexOf("CanadianFrench") >= 0) {
                  language = "fr-CA";
                }
                if (language.indexOf("c0a") >= 0) {
                  language = "es-ES";
                }
                if (language.indexOf("80a") >= 0) {
                  language = "es-MX";
                }
                if (language.indexOf("816") >= 0) {
                  language = "pt-PT";
                }

                if (language.indexOf("416") >= 0) {
                  language = "pt-BR";
                }
                if (language.indexOf("401") >= 0) {
                  language = "ar-SA";
                }
                if (language.indexOf("40A") >= 0) {
                  language = "es-ES";
                }
                if (language.indexOf("411") >= 0) {
                  language = "ja-JP";
                }
                if (language.indexOf("540A") >= 0) {
                  language = "es-US";
                }
                if (language.indexOf("USSpanish") >= 0) {
                  language = "es-US";
                }
                if (language.indexOf("c0a") >= 0) {
                  language = "es-US";
                }

                var shortName = voicename;
                var i = voicename.indexOf('22k_HQ');
                if (i > -1) {
                  shortName = voicename.substring(0, i);
                }
                var nameIndex = $.inArray(shortName, voiceNames);
                if (nameIndex < 0) {
                  voiceNames.push(voicename);
                  var localVoice = null;
                  if (type === 'Aca') {
                    //voicename = voicename + ' (natural voice)';
                    // localVoice = new FreeVoice(voicename, language, 'local aca', idname);
                    let languageLocale = this.voiceUtilService.getLanguageAndLocaleForVoiceList(language);
                    let key = voicename + ' ' + language + ' ' + 'free';
                    localVoice = new FreeVoice(key, voicename, language, languageLocale.localeName, languageLocale.displayLocale, 'local aca', languageLocale.languageName, idname);
                    localAcaVoices.push(localVoice);
                  } else {
                    // if (voicename.indexOf('Microsoft') > -1) {
                    //   if (voicename.indexOf('Desktop') > -1) {
                    //     voicename = voicename.replace('Microsoft', '');
                    //     voicename = $.trim(voicename);
                    //     localVoice = new FreeVoice(voicename, language, 'local sapi', idname);
                    //     localAcaVoices.push(localVoice);
                    //   }
                    // } else {
                    //   voicename = $.trim(voicename);
                    //   localVoice = new FreeVoice(voicename, language, 'local sapi', idname);
                    //   localAcaVoices.push(localVoice);
                    // }
                    // voicename = voicename.replace('Microsoft', '');
                    // voicename = voicename.replace('Desktop', '');
                    voicename = $.trim(voicename);
                    // localVoice = new FreeVoice(voicename, language, 'local sapi', idname);
                    let languageLocale = this.voiceUtilService.getLanguageAndLocaleForVoiceList(language);
                    let key = voicename + ' ' + language + ' ' + 'free';
                    localVoice = new FreeVoice(key, voicename, language, languageLocale.localeName, languageLocale.displayLocale, 'local sapi', languageLocale.languageName, idname);
                    localAcaVoices.push(localVoice);
                  }
                }
              }
            });
          } else {
            temp = [];
            localAcaList.system.forEach(item => {
              item['list'].forEach(voice => {
                // console.error(voice);
                //voice.VoiceName = voice.VoiceName + ' (system voice)';
                // const sysVoice = new FreeVoice(voice.VoiceName, voice.VoiceLocaleIdentifier.replace(/_/g, '-'), 'system voice', voice.VoiceIdentifier);
                let language = voice.VoiceLocaleIdentifier.replace(/_/g, '-');
                let languageLocale = this.voiceUtilService.getLanguageAndLocaleForVoiceList(language);
                let key = voice.VoiceName + ' ' + language + ' ' + 'free';
                const sysVoice = new FreeVoice(key, voice.VoiceName, language, languageLocale.localeName, languageLocale.displayLocale, 'system voice', languageLocale.languageName, voice.VoiceIdentifier);
                if (this.voiceUtilService.getLanguageName(sysVoice.language) !== '') {
                  localAcaVoices.push(sysVoice);
                }
              });
            });
            localAcaList.aca.forEach(item => {
              item['list'].forEach(voice => {
                if (voice.VoiceLanguage.indexOf("USEnglish") >= 0) {
                  voice.VoiceLanguage = "en-US";
                } else if (voice.VoiceLanguage.indexOf("USSpanish") >= 0 && voice.VoiceName == 'Rosa') {
                  voice.VoiceLanguage = "es-US";
                }
                //voice.VoiceName = voice.VoiceName + ' (natural voice)';
                // const acaVoice = new FreeVoice(voice.VoiceName, voice.VoiceLanguage, 'local aca', voice.idname);
                let languageLocale = this.voiceUtilService.getLanguageAndLocaleForVoiceList(voice.VoiceLanguage);
                let key = voice.voiceName + ' ' + voice.VoiceLanguage + ' ' + 'free';
                const acaVoice = new FreeVoice(key, voice.VoiceName, voice.VoiceLanguage, languageLocale.localeName, languageLocale.displayLocale, 'local aca', languageLocale.languageName, voice.idname);
                localAcaVoices.push(acaVoice);
              });
            });
          }

          temp = temp.concat(localAcaVoices);
          resolve(temp);
        });
      }
    })
      .then((voices: Array<FreeVoice>) => {
        return this.sortVoices(voices);
      })
      .then((voices: Array<FreeVoice>) => {
        // console.log("free voices data", voices);
        for (let i = 0; i < voices.length; i++) {
          let name = (voices[i].source === 'google') ? this.getGoogleVoiceName(voices[i]) : voices[i].name;
          this.voices.set(name + ' ' + voices[i].language + ' ' + 'free', voices[i]);
        }
      })
      .catch(function(err) {
        //alert('sorteeeeeeee error' + err);
        console.log(err);
      });
  }



  getName(name: string, source: string) {
    if (source === "acapela") {
      name = name.split(" ")[0];
    }
    if (name == "native") {
      name = "Native";
    } else {
      name = name.split("-")[0];
      name = name.replace("Microsoft", "");
    }
    if (name == "Aaron") name = "Mia";
    if (name == "Marie") name = "Louis";

    return name;
  }

  // formatAndroidVoiceLang(lang: string) {
  //   return lang.replace("_", "-");
  // }

  formatAndroidVoiceName(name: string) {
    let version = '';
    let voiceAry = name.split('#');
    if (voiceAry.length > 1) {
      let prefixAry = voiceAry[0].split('-');
      if (prefixAry.includes('x')) {
        version = '(' + prefixAry[prefixAry.length - 1] + ')';
      }
      return voiceAry[1] + version;
    } else {
      voiceAry = name.split('-');
      if (voiceAry.includes('x')) {
        version = '(' + voiceAry[voiceAry.length - 2] + ')';
      }
      return voiceAry[voiceAry.length - 1] + version;
    }
  }

  getLanguage(lang: string, name: string) {
    // TODO: add more languages for sw
    console.log('py test lang:', lang);
    if (name == "native") {
      return "en-US";
    }
    if (lang.indexOf("en-US") >= 0 || lang.indexOf("en_US") >= 0) {
      return "en-US";
    } else if (lang.indexOf("en-UK") >= 0 || lang.indexOf("en_UK") >= 0) {
      return "en-UK";
    } else if (lang.indexOf("en-GB") >= 0 || lang.indexOf("en_GB") >= 0) {
      return "en-GB";
    } else if (lang.indexOf("de-DE") >= 0 || lang.indexOf("de_DE") >= 0) {
      return "de-DE";
    } else if (lang.indexOf("fr-FR") >= 0 || lang.indexOf("fr_FR") >= 0) {
      return "fr-FR";
    } else if (lang.indexOf("it-IT") >= 0 || lang.indexOf("it_IT") >= 0) {
      return "it-IT";
    } else if (lang.indexOf("sv-SE") >= 0 || lang.indexOf("sv_SE") >= 0) {
      return "sv-SE";
    } else if (lang.indexOf("fr-CA") >= 0 || lang.indexOf("fr_CA") >= 0) {
      return "fr-CA";
    } else if (lang.indexOf("es-ES") >= 0 || lang.indexOf("es_ES") >= 0) {
      return "es-ES";
    } else if (lang.indexOf("pt-PT") >= 0 || lang.indexOf("pt_PT") >= 0) {
      return "pt-PT";
    } else if (lang.indexOf("fr-CA") >= 0 || lang.indexOf("fr_CA") >= 0) {
      return "fr-CA";
    } else if (lang.indexOf("es-US") >= 0 || lang.indexOf("es_US") >= 0) {
      return "es-US";
    } else if (lang.indexOf("pt-BR") >= 0 || lang.indexOf("pt_BR") >= 0) {
      return "pt-BR";
    } else if (lang.indexOf("nl-NL") >= 0 || lang.indexOf("nl_NL") >= 0) {
      return "nl-NL";
    } else if (lang.indexOf("zh_CN") >= 0 || lang.indexOf("zh-CN") >= 0) {
      return "zh_CN";
    } else if (lang.indexOf("zh_HK") >= 0 || lang.indexOf("zh-HK") >= 0) {
      return "zh_HK";
    } else if (lang.indexOf("zh_TW") >= 0 || lang.indexOf("zh-TW") >= 0) {
      return "zh_TW";
    }
    else if (lang.indexOf("ja_JP") >= 0 || lang.indexOf("ja-JP") >= 0) {
      return "ja_JP";
    }
    else if (lang.indexOf("ko_KR") >= 0 || lang.indexOf("ko-KR") >= 0) {
      return "ko_KR";
    }
    else if (lang.indexOf("ar_") >= 0 || lang.indexOf("ar-") >= 0) {
      return "ar";
    }
    else {
      return "";
    }
  }

  getVoiceSource(voice) {
    if (voice.name.toLowerCase().indexOf("google") >= 0) {
      return "google";
    } else if (voice.name.toLowerCase().indexOf("acapela") >= 0) {
      return "acapela";
    } else if (voice.name.toLowerCase().indexOf("att") >= 0) {
      return "att";
    } else if (voice.name.toLowerCase().indexOf("natural") >= 0) {
      return "natural";
    } else {
      if (voice.voiceURI.toLowerCase().indexOf("com.apple") >= 0) {
        if (
          voice.name.toLowerCase().indexOf("samantha") >= 0 ||
          voice.name.toLowerCase().indexOf("daniel") >= 0 ||
          voice.name.toLowerCase().indexOf("monica") >= 0 ||
          voice.name.toLowerCase().indexOf("joana") >= 0 ||
          voice.name.toLowerCase().indexOf("luciana") >= 0 ||
          voice.name.toLowerCase().indexOf("alva") >= 0 ||
          this.appleLangs.includes(voice.lang)
        ) {
          return "apple";
        } else {
          this.appleLangs.push(voice.lang);
          return "free";
        }
      } else {
        return "free";
      }
    }
  }

  public sortVoices(voices: Array<FreeVoice>) {

    return new Promise((resolve, reject) => {
      voices.sort((obj1, obj2) => {
        function getNameWeight(name) {
          name += "";
          name = name.toLowerCase();
          // if (name == "alex") return 1;
          // if (name == "samantha") return 2;
          // if (name == "tom") return 3;
          // if (name == "daniel") return 4;
          // if (name == "serena") return 5;
          // return 999;
          if (name.indexOf('local') > -1) {
            return 1;
          } else {
            return 2;
          }
        }

        function getLangNameWeight(name) {
          if (name.indexOf("English") >= 0) {
            if (name == "English (US)") return 1;
            if (name == "English (UK)") return 2;
            return 3;
          }
          if (name.indexOf("Spanish") >= 0) return 4;
          if (name.indexOf("French") >= 0) return 5;
          if (name.indexOf("German") >= 0) return 6;
          if (name.indexOf("Italian") >= 0) return 7;
          if (name.indexOf("Portuguese") >= 0) return 8;
          if (name.indexOf("Swedish") >= 0) return 9;
          if (name.indexOf("Dutch") >= 0) return 10;
          return 999;
        }

        var val1 = getNameWeight(obj1.source);
        var val2 = getNameWeight(obj2.source);
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          var langVal1 = getLangNameWeight(obj1.languageName);
          var langVal2 = getLangNameWeight(obj2.languageName);
          if (langVal1 < langVal2) { return -1; };
          if (langVal1 > langVal2) { return 1; };
          if (langVal1 == langVal2) {
            if (obj1.languageName < obj2.languageName) { return -1; };
            if (obj1.languageName > obj2.languageName) { return 1; };
          }
          return 0;
        }
      });
      resolve(voices);
    }).catch(function(err) {
      console.log(err);
    });
  }

  getGoogleVoiceName(voice: FreeVoice) {
    switch (voice.language) {
      case "en-US": ;
        return "Gale";
      case "en-GB":
        if (voice.name === "Google UK English Male") {
          return "Gabriel";
        } else if (voice.name === "Google UK English Female") {
          return "Grace";
        }
      case "es-ES":
        return "Anna";
      case "es-US":
        return "Mariana";
      case "it-IT":
        return "Sofia";
      case "nl-NL":
        return "Margreet";
      case "fr-FR":
        return "Sophia";
      case "pt-BR":
        return "Carolina";
      case "de-DE":
        return "Mia";
    }
  }

  public getVoices() {
    return this.voices;
  }

}
